export function BasketIcon({
  className,
  style,
}: {
  className?: string;
  style?: React.CSSProperties;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      className={className}
      style={style}
    >
      <g
        id="System_Icons"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="System/Icons"
          transform="translate(-110.000000, -189.000000)"
          fill="currentColor"
        >
          <g
            id="atom/icon/shopping-cart-empty"
            transform="translate(110.000000, 189.000000)"
          >
            <path
              d="M17.52,5.07 C17.5820143,4.84025256 17.5313168,4.59470792 17.3833809,4.40830877 C17.2354451,4.22190962 17.0078278,4.11677758 16.77,4.125 L3.9375,4.125 C3.84797638,4.12397169 3.77065475,4.06211439 3.75,3.975 L3.3225,1.935 C3.08232147,0.808865471 2.08895826,0.00292927979 0.9375,0 C0.419733047,0 0,0.419733047 0,0.9375 C0,1.45526695 0.419733047,1.875 0.9375,1.875 C1.20115021,1.87596169 1.428756,2.05991706 1.485,2.3175 L3.8625,13.6275 C3.98624702,14.2070038 4.31685819,14.7215841 4.7925,15.075 C4.8368613,15.1094774 4.86419607,15.1614135 4.8675,15.2175 C4.86930309,15.2752274 4.84440138,15.3305646 4.8,15.3675 C4.27236936,15.8188167 4.12343045,16.5732554 4.43996602,17.1912247 C4.75650158,17.809194 5.45577268,18.1291635 6.13033262,17.9646955 C6.80489256,17.8002274 7.27841872,17.194312 7.275,16.5 C7.27475273,16.2683226 7.22084378,16.0398513 7.1175,15.8325 C7.08371417,15.7772562 7.08371417,15.7077438 7.1175,15.6525 C7.15102863,15.5974103 7.21051584,15.5634176 7.275,15.5625 L11.775,15.5625 C11.8421508,15.5607781 11.9050922,15.5951098 11.94,15.6525 C11.9706829,15.7085773 11.9706829,15.7764227 11.94,15.8325 C11.8316244,16.0383048 11.7749932,16.2674041 11.775,16.5 C11.775,17.3284271 12.4465729,18 13.275,18 C14.1034271,18 14.775,17.3284271 14.775,16.5 C14.7735921,16.2651866 14.7170758,16.0339834 14.61,15.825 C14.5840076,15.767815 14.5840076,15.702185 14.61,15.645 C14.6452949,15.5927739 14.7044701,15.5617774 14.7675,15.5625 C15.285267,15.5625 15.705,15.142767 15.705,14.625 C15.705,14.107233 15.285267,13.6875 14.7675,13.6875 L6.2475,13.6875 C5.98384979,13.6865383 5.756244,13.5025829 5.7,13.245 L5.565,12.6 C5.53963382,12.550564 5.53963382,12.491936 5.565,12.4425 C5.61296177,12.3768496 5.69776886,12.3495902 5.775,12.375 L13.815,12.375 C14.8283063,12.3736099 15.7156634,11.6950427 15.9825,10.7175 L17.52,5.07 Z"
              id="Path"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
